import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { QUERY_KEY_ACTIVITIES_UPDATED_DATE } from 'Data/keys/QueryKeys';
import { IFiltersRequestUpdatedDate } from 'Data/interfaces/Activities/IFiltersRequest';
import { ActivitiesApi } from 'Data/ActivitiesApi';
import dayjs from 'dayjs';

export const useQueryUpdatedDate = (request: IFiltersRequestUpdatedDate) => {
  const { data, refetch, isLoading, isFetching, error } = useQuery({
    queryKey: [QUERY_KEY_ACTIVITIES_UPDATED_DATE, Number(request.csId), request.from, request.to],
    staleTime: 60 * 5 * 1000, // 5 minutes
    enabled: !!request.csId && (dayjs(request.from).isValid() || dayjs(request.to).isValid()),
    queryFn: async () => {
      const response = await ActivitiesApi.listUpdatedDate(request);
      return response.data.data;
    },
  });

  const dataDefault = useMemo(() => [], []);

  return {
    data: data ?? dataDefault,
    refetch,
    isLoading,
    isFetching,
    error,
  };
};
